import React from 'react';
import styles from './styles';
import {AutoComplete} from 'antd';
import { FormattedMessage } from 'react-intl';

const getTextInput = (props: any) => {
  return (
    <AutoComplete {...props} style={{...styles.inputDefault, ...props.style}}>
    </AutoComplete>
  );
};

const getTextInputWithPlaceholder = (props: any) => {
  return (
    <FormattedMessage id={props.placeholder}>
      {(p: any) => <AutoComplete {...props} placeholder={p} style={{...styles.inputDefault, ...props.style}} />}
    </FormattedMessage>
  );
};

export const RBHAutoComplete = (props: any) => {
  return props.placeholder ? getTextInputWithPlaceholder(props) : getTextInput(props);
};

export default RBHAutoComplete;
